import { render } from "./Index.vue?vue&type=template&id=7542edeb"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7542edeb&lang=css"
script.render = render

export default script